const ChartJSPluginLegendEvent = {
    id: 'legendEvent',
    afterEvent: (chart, event) => {
        if (!chart.config.options.legend.display) return

        const legend = chart.legend
        if (!legend) return
        const cursorChanged = legend.legendItems.some((legendItem, index) => {
            const box = legend.legendHitBoxes[index]
            if (event.x >= box.left && event.x <= box.left + box.width &&
                event.y >= box.top && event.y <= box.top + box.height) {
                event.native.target.style.cursor = 'pointer'
                return true
            }
        })
        if (!cursorChanged) {
            event.native.target.style.cursor = 'default'
        }
    }
}
export default ChartJSPluginLegendEvent
